import { AiFillCaretDown, AiFillCaretRight, AiOutlineMenu } from "react-icons/ai";
import Button from "../Button/Button";
import logo from "../../assets/oq-logo-1.svg";
import logoWhite from "../../assets/oq-logo-1-white.svg";
import { ImCross } from "react-icons/im";
import "./NavBar.scss";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import PRODUCTS from "../../pages/SignUpPage/products";

const NavBar = () => {
  const [productsMenuOpen, setProductsMenuOpen] = useState(true);
  const location = useLocation();

  // Close dropdown when route changes
  useEffect(() => {
    setProductsMenuOpen(false);
    const navLinks = document.querySelector(".nav-links") as HTMLDivElement;
    if (navLinks) {
      navLinks.classList.remove("show-products");
    }
    // Force close dropdown on desktop
    const productsMenuItem = document.querySelector(".products-menu-item") as HTMLLIElement;
    if (productsMenuItem) {
      productsMenuItem.classList.add("dropdown-closed");
      setTimeout(() => {
        if (productsMenuItem) {
          productsMenuItem.classList.remove("dropdown-closed");
        }
      }, 200);
    }
  }, [location.pathname]);

  const menuOpenButtonClicked = (e: any) => {
    const navLinks = document.querySelector(".nav-links") as HTMLDivElement;
    if (navLinks) {
      (navLinks as HTMLDivElement).style.left = "0px";
    }
  };

  const menuCloseButtonClicked = (e: any) => {
    const navLinks = document.querySelector(".nav-links") as HTMLDivElement;
    
    if (navLinks) {
      (navLinks as HTMLDivElement).style.left = "-100%";
    }
    setProductsMenuOpen(false);
  };

  // This method is only called for menu links which navigate to an anchored id (#), because those will naturally not close the menu,
  // whereas menu links which link to another page WILL close the menu automatically
  const closeMobileMenuIfOpen = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const navLinks = document.querySelector(".nav-links") as HTMLDivElement;
    if (navLinks &&  (navLinks as HTMLDivElement).style.left === "0px") {
      (navLinks as HTMLDivElement).style.left = "-100%";
    }
    setProductsMenuOpen(false);
  }

  const handleProductClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    // Close the dropdown when a product is clicked
    setProductsMenuOpen(false);
    const navLinks = document.querySelector(".nav-links") as HTMLDivElement;
    if (navLinks) {
      navLinks.classList.remove("show-products");
      if (navLinks.style.left === "0px") {
        navLinks.style.left = "-100%";
      }
    }
    // Force close dropdown on desktop
    const productsMenuItem = document.querySelector(".products-menu-item") as HTMLLIElement;
    if (productsMenuItem) {
      productsMenuItem.classList.add("dropdown-closed");
      setTimeout(() => {
        if (productsMenuItem) {
          productsMenuItem.classList.remove("dropdown-closed");
        }
      }, 200);
    }
    closeMobileMenuIfOpen(e);
  }

  const productsMenuClicked = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.innerWidth <= 850) {
      // Mobile: toggle dropdown
      const navLinks = document.querySelector(".nav-links") as HTMLDivElement;
      if (navLinks) {
        navLinks.classList.toggle("show-products");
      }
      setProductsMenuOpen(!productsMenuOpen);
    }
    // Desktop: hover will handle it via CSS
  }

  const handleProductsMouseEnter = () => {
    if (window.innerWidth > 850) {
      setProductsMenuOpen(true);
    }
  }

  const handleProductsMouseLeave = () => {
    if (window.innerWidth > 850) {
      setProductsMenuOpen(false);
    }
  }

  // const subMenu1Clicked = (e: any) => {
  //     navLinks.classList.toggle("show1");
  // }

  // const subSubMenu1Clicked = (e: any) => {
  //     navLinks.classList.toggle("show2");
  // }

  // const subMenu2Clicked = (e: any) => {
  //     navLinks.classList.toggle("show3");
  // }

  return (
    <div id="NavBar">
      <nav>
        <div className="navbar">
          <AiOutlineMenu
            className="bx bx-menu"
            onClick={menuOpenButtonClicked}
            height={"20px"}
          />
          <div className="logo">
            <Link to={"/"}>
              <img src={logo} alt="OphthalmologyQ" className="navbar-logo" />
            </Link>
          </div>
          <div className="nav-links">
            <div className="sidebar-logo">
              {/* <span className="logo-name">CodingLab</span> */}
              <img src={logoWhite} alt="logo" className="logo-name" />
              <ImCross
                className="bx bx-x"
                onClick={menuCloseButtonClicked}
                color="white"
              />
            </div>
            <ul className="links">
              <li>
                {/* IMPORTANT: Link used to ensure site doesn't reload, especially becaue we need to include window.location.origin,
                so the navigation works from any public page across the whole site */}
                <Link to={window.location.origin + '/#about-oq'} onClick={closeMobileMenuIfOpen}>About OQ</Link>
              </li>
              <li>
                <Link to={window.location.origin + '/#why-us'} onClick={closeMobileMenuIfOpen}>Why Us</Link>
              </li>
              <li>
                <Link to={window.location.origin + '/#our-vision'} onClick={closeMobileMenuIfOpen}>Our Vision</Link>
              </li>
              <li className="products-menu-item">
                <a 
                  href="#" 
                  onClick={productsMenuClicked} 
                  onMouseEnter={handleProductsMouseEnter}
                  onMouseLeave={handleProductsMouseLeave}
                  className="products-menu-link"
                >
                  Resources
                  <AiFillCaretDown className={`bx bxs-chevron-down products-menu-arrow products-menu-arrow-down arrow ${productsMenuOpen ? 'show' : ''}`}/>
                  <AiFillCaretRight className={`bx bxs-chevron-right products-menu-arrow products-menu-arrow-right arrow ${productsMenuOpen ? '' : 'show'}`}/>
                </a>
                <ul className={`products-sub-menu sub-menu ${productsMenuOpen ? 'show' : ''}`}>
                  {PRODUCTS.filter(p => !p.comingSoon || p.id === "portfolio_builder" || p.id === "interview_coaching").map(product => (
                    <li key={product.id}>
                      <Link to={`/products/${product.id}`} onClick={handleProductClick} className="nav-product-link">
                        <span className="nav-product-link-text">{product.title}{product.price > 0 ? ` (£${product.price})` : ''}</span>
                        {product.id === 'interview_coaching' && (
                          <span className="nav-product-pill nav-product-pill-limited">Limited spaces</span>
                        )}
                        {product.comingSoon && (
                          <span className="nav-product-pill nav-product-pill-coming-soon">coming soon</span>
                        )}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              {/* <li>
                <Link to={window.location.origin + '/#newsletter'} onClick={closeMobileMenuIfOpen}>Newsletter</Link>
              </li> */}
              <li className="hideInDesktopView">
                <Link to={"/sign-up"}>Sign Up</Link>
              </li>
              <li className="hideInDesktopView">
                <Button text="Login" linkTo="/login"/>
              </li>
              {/* <li>
                  <a onClick={subMenu1Clicked}>HTML & CSS</a>
                  <AiFillCaretDown className='bx bxs-chevron-down submenu-1-arrow arrow'/>
                  <ul className="htmlCss-sub-menu sub-menu">
                      <li><a>Web Design</a></li>
                      <li><a>Login Forms</a></li>
                      <li><a>Card Design</a></li>
                      <li className="more">
                          <span><a onClick={subSubMenu1Clicked}>More</a>
                              <AiFillCaretRight className='bx bxs-chevron-right arrow sub-submenu-1-arrow'/>
                          </span>
                          <ul className="more-sub-menu sub-menu">
                              <li><a>Neumorphism</a></li>
                              <li><a>Pre-loader</a></li>
                              <li><a>Glassmorphism</a></li>
                          </ul>
                      </li>
                  </ul>
              </li>
              <li>
                  <a onClick={subMenu2Clicked}>JAVASCRIPT</a>
                  <AiFillCaretDown className='bx bxs-chevron-down submenu-2-arrow arrow'/>
                  <ul className="js-sub-menu sub-menu">
                      <li><a>Dynamic Clock</a></li>
                      <li><a>Form Validation</a></li>
                      <li><a>Card Slider</a></li>
                      <li><a>Complete Website</a></li>
                  </ul>
              </li> */}
            </ul>
          </div>
          <ul className="search-box">
            <li>
              <Link to={"/sign-up"}>Sign Up</Link>
            </li>
            {/* <li>
              <Link to={"/contact-us"}>Contact us</Link>
            </li> */}
            <Button text="Login" linkTo="/login" />
            {/* <i className='bx bx-search'></i>
              <div className="input-box">
                  <input type="text" placeholder="Search..."/>
              </div> */}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
